import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AppProvider } from './hooks';
import Router from './routes';

const theme = createTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '*': {
          margin: 0,
          padding: 0,
          outline: 0,
          boxSizing: 'border-box',
        },
        body: {
          WebkitFontSmoothing: 'antialiased',
        },
        'body, input, button': {
          fontFamily: 'Montserrat, sans-serif',
          fontSize: '16px',
        },
        button: {
          cursor: 'pointer',
        },
      },
    },
  },
});
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <AppProvider>
              <Router />
              <ToastContainer toastStyle={{ fontFamily: 'montserrat' }} />
            </AppProvider>
          </BrowserRouter>
        </ThemeProvider>
      </StyledEngineProvider>

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
